<template>
 <div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
         <div class="searchBox inpBox">
            <div class="item">
              <el-form-item label="业务名称:" prop="businessName">
                <el-input placeholder="" v-model="searchFrom.businessName"></el-input>
              </el-form-item>
              <el-form-item label="解析方法名称:" prop="methodName">
                <el-input placeholder="" v-model="searchFrom.methodName"></el-input>
              </el-form-item>
            </div>
        </div> 
        <div class="searchBtnBox">
              <el-form-item>
                  <el-button type="primary" @click="searchFn">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="applyClick">新增</el-button>
                </el-form-item>
            </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
         <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="mini" @click="delFn(scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="businessName"  min-width="200" :formatter="emptyFn" label="业务名称"></el-table-column> 
        <el-table-column prop="methodName"  min-width="200" :formatter="emptyFn" label="解析方法名称"></el-table-column> 
        <el-table-column prop="remark"  min-width="270" :formatter="emptyFn" label="备注信息"></el-table-column>
        <el-table-column prop="createUserName"  min-width="120" :formatter="emptyFn" label="创建人"></el-table-column>
        <el-table-column prop="createTime"  min-width="160" :formatter="dateTimeFormat" label="创建时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
     <el-dialog  title="添加解析方法"  :visible.sync="SQMark" width="400px" class="detail"  :close-on-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
       <el-form :inline="true"  :model="SQFrom" ref="SQFrom" :rules="rules" class="demo-form-inline jiaoyan" label-width="130px" size="mini">
        <div class="inpBox">
            <div style="margin: 28px 0;">
                <el-form-item label="业务名称:" prop="businessName">
                  <el-input v-model="SQFrom.businessName" placeholder="" maxlength="50"></el-input>
                </el-form-item>
                <el-form-item label="解析方法名称:" prop="methodName">
                  <el-input v-model="SQFrom.methodName" placeholder="" maxlength="20"></el-input>
                </el-form-item>
                <el-form-item label="备注信息:" prop="remark" >
                  <el-input type="textarea" v-model="SQFrom.remark" style="width:150px"></el-input>
                </el-form-item>
             </div>
        </div>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="SQMark = false">取消</el-button>
        <el-button type="primary" @click="SQsave()">确定</el-button>
      </span>
   </el-dialog>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import { 
         cOcrModelMethodAdd, // 添加确定
         cOcrModelMethodList, // 列表
         cOcrModelMethodDelete // 删除
         } from '@/api/common-signature'
export default {
  data () {
    return {
      SQFrom: {
      },
      SQMark: false,
      rules: {
        methodName: [
          { required: true, message: '请输入解析方法名称', trigger: 'blur' }
        ],
        businessName: [
          { required: true, message: '请输入业务名称', trigger: 'blur' }
        ],
      },
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      dialogVisible: false,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      loading: false,
      btnFlg: [],
      btnIdArr: ['004P003B000', '004P003B001', '004P003B002']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/systemSetup/address')
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
  },
  methods: {
     SQsave () {
        this.$refs.SQFrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
        cOcrModelMethodAdd(this.SQFrom).then(res => {
            loading.close()
            this.$message({
              message: '成功',
              type: 'success'
            })
            this.SQMark = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 删除
    delFn (row) {
      this.$confirm('是否执行删除操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        cOcrModelMethodDelete({ id: row.id }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
     // 申请签章 
    applyClick(){
      this.SQMark = true
      this.$nextTick(() => {
        this.$refs["SQFrom"].clearValidate(); 
      })
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      cOcrModelMethodList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTime: null
      }
    },
    closeDialog () {
      this.SQFrom = {
      }
    },
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
  width: 350px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}

</style>
